import { Component, ElementRef, EventEmitter, Output, ViewChild, HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// import * as _ from 'underscore';
import * as bigdecimal from 'bigdecimal';
import _ from 'lodash';
import * as moment from 'moment';
import { DateModel, DatePickerOptions } from 'ng2-datepicker';
import { Subject, Subscription } from "rxjs";
import { IWorkBook } from "ts-xlsx";
import { IWorkSheet } from "xlsx";
import { FareRateDetailRoute, FareRateDetailSum } from '../../../../containers/index';
import { AirLine, AirLineService, Airport, AirPortService, AlertService, CnsltnQuotCstModel, CnsltnQuotModel, CnsltnQuotRouteModel, CnsltnReqModel, Corporation, CostItemModel, Country, CountryService, CrncyRateModel, CstGrpModel, CstModel, CstSubTotalModel, ExcelService, FareService, ForwarderService, Location, NodeType, OceanLine, OceanLineService, Port, PortService, QuotationService, RouteModel, CurrencyService } from '../../../../services/index';
import { Util } from '../../../../utils/index';
import { FormControl } from '@angular/forms';
declare var $:any;

export interface UploadResult {
  result: "failure" | "success";
  payload: any;
}

@Component({
    selector:'fare-detail',
    templateUrl: 'fare-detail.html'
})


export class FareRateDetailContainer {
  //운임항목 데이터
  private cnsltnOrgQuotCstList: Array<CnsltnQuotCstModel> = new Array<CnsltnQuotCstModel>();
  private cnsltnTransQuotCstList: Array<CnsltnQuotCstModel> = new Array<CnsltnQuotCstModel>();
  private cnsltnDesQuotCstList: Array<CnsltnQuotCstModel> = new Array<CnsltnQuotCstModel>();

  //운임항목 총계
  private cstSubTotalList: Array<CstSubTotalModel> = new Array<CstSubTotalModel>();
  private orgCstSubTotal:CstSubTotalModel = new CstSubTotalModel();
  private desCstSubTotal:CstSubTotalModel = new CstSubTotalModel();
  private transCstSubTotal:CstSubTotalModel = new CstSubTotalModel();
  private cstTotal:CstSubTotalModel = new CstSubTotalModel();

  //항목, 통화 
  private costItemList:Array<CostItemModel> = new Array<CostItemModel>();
  private crncyRateList:Array<CrncyRateModel> = new Array<CrncyRateModel>();

  //엑셀 
  private filesSubject: Subject<File>;
  
  //견적서 정보
  //private availDt:DateModel;
  private availDtOptions: DatePickerOptions;
  //private wrtDt:DateModel;
  private wrtDtOptions:DatePickerOptions;
  private forwarder:string
  private linerNm:string
  private linerCd:string
  private transNm:string
  private exptDys:string
  private cnsltnQuot:CnsltnQuotModel = new CnsltnQuotModel();
  private cnsltnReq:CnsltnReqModel = new CnsltnReqModel();
  public reqNo:string;
  private quotNo:string;

  today = moment(new Date()).format('YYYY/MM/DD');

  private itemUnitList:Array<any>;

  private tabIndex:number = 0;
  //Line Select
  private focusedLineIndex: number = 0;
  private selectedLine:any;
  private isLineListOpen: boolean = false;
  private filteredLineList: Array<any> = [];

  private countries: Array<Country> = [];
	private ports: Array<Port> = [];
	private airports: Array<Airport> = [];
  private airLines: Array<AirLine> = [];
  private oceanLines: Array<OceanLine> = [];

  currencyList:  Array<CrncyRateModel> = [];

  private isTempSave = true;
  @ViewChild("LineList") lineListRef: ElementRef;

  @Output()
  public uploadedXls: EventEmitter<UploadResult> = new EventEmitter();
  
  @ViewChild('fareRateRoute') fareRateRoute:FareRateDetailRoute;
  @ViewChild('fareRateSum') fareRateSum:FareRateDetailSum;

  lineInput:FormControl =  new FormControl();

  countryListEeSub:Subscription;
	airportListEeSub:Subscription;
	portListEeSub:Subscription;
	oceanLineListEeSub:Subscription;
	airLineListEeSub:Subscription;
 
  tempAllList = {
    countries:null,
    ports:null,
    airports:null,
    oceanLines:null,
    airLines:null,
  }

  allList = null;

  private fwdrCorpList = Array<Corporation>();

  isSearching:boolean = false;
  isSave:boolean = false;

  subs:Subscription = new Subscription();
  exchangeSubs: Map<string, Subscription[]> = new Map();

  availDt;
  wrtDt;
  isImpossible: boolean = false;

  cnsltnQuotRouteList: Array<CnsltnQuotRouteModel>;
  
  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    event.returnValue = false;
  }

  constructor(
    private route: ActivatedRoute,
    private excelService: ExcelService,
    private fareService: FareService,
    private quotationService: QuotationService,
    private alertService: AlertService,
    private oceanLineService: OceanLineService,
    private airLineService: AirLineService,
    private airPortService: AirPortService,
    private portService: PortService,
    private countryService: CountryService,
    private router:Router,
    private forwarderService: ForwarderService,
    private currencyService: CurrencyService
  ){
    forwarderService.getCorpList().subscribe((res:any) =>{
      this.fwdrCorpList = _.filter(res.data, (fwdrCorp:Corporation) => {
        if(fwdrCorp.typeCd == 1 || fwdrCorp.corpId == 150) return true;
        else return false;        
      });
    });
  }

  canDeactivate() {
    return confirm("페이지를 이동하시겠습니까?");
  }


  setAllList(){
    
    this.countryListEeSub = this.countryService.countryListEe.subscribe(countries => {
      this.countries = countries;
      this.tempAllList.countries = this.countries;
      this.checkAllListValue();
    });
    if(!this.countryService.ingFlag){
      this.countryService.getCountries();
    }

		this.portListEeSub = this.portService.portListEe.subscribe(ports => {
      this.ports = ports;
      this.tempAllList.ports = this.ports;
      this.checkAllListValue();
    });
    if(!this.portService.ingFlag){
      this.portService.getPortList();
    }
    
		this.airportListEeSub = this.airPortService.airPortListEe.subscribe(airports => {
      this.airports = airports;
      this.tempAllList.airports = this.airports;
      this.checkAllListValue();
    });
    if(!this.airPortService.ingFlag) {
      this.airPortService.getAirPortList();
    }

		this.oceanLineListEeSub = this.oceanLineService.lineListEe.subscribe(oceanLines => {
      this.oceanLines = oceanLines;
      this.tempAllList.oceanLines = this.oceanLines;
      this.checkAllListValue();
    });
    if(!this.oceanLineService.ingFlag){
      this.oceanLineService.getOceanLineList();
    }

		this.airLineListEeSub = this.airLineService.lineListEe.subscribe(airLines => {
      this.airLines = airLines;
      this.tempAllList.airLines = this.airLines;
      this.checkAllListValue();
    });
    if(!this.airLineService.ingFlag){
      this.airLineService.getAirLineList();
    }
    
  }

  moveCnsltnDetail(){
    this.router.navigate(['/quotation/consult-detail', this.reqNo]);
  }

  checkAllListValue(){
    if(
      this.isSearching ||
      this.tempAllList.airLines == null || 
      this.tempAllList.airports == null || 
      this.tempAllList.countries == null || 
      this.tempAllList.oceanLines == null || 
      this.tempAllList.ports == null){
        return;
    }
    this.allList = this.tempAllList;
    //this.goNgOnInit();
    this.goNgOnInit2();
  }

  getCrncyRateByCntryCd(cntryCd:string){
    return _.find(this.currencyList, {cntryCd : cntryCd });
  }

  getCrncyRateByCrncyCd(crncyCd:string){
    return _.find(this.currencyList, {crncyCd : crncyCd });
  }
  
  goNgOnInit2(){
    const route = this.route.params.subscribe(params => {
       this.reqNo = params['id'];
       this.quotNo = params['id2'];
    });
    this.subs.add(route);

    //CostItem 조회
    this.fareService.getCostItem().subscribe((costItemList:Array<CostItemModel>) => {
      this.costItemList = costItemList;
    });
    
    //Currency List 조회
    this.currencyList = this.currencyService.currencyList;
    if (!this.currencyList || this.currencyList.length <= 0) {
      this.currencyService.currencyListEe.subscribe(crncyList => this.currencyList = crncyList);
    }
    
    //견적 요청 정보

    this.isSearching = true;
    
    const consult = this.quotationService.getConsultReport(this.reqNo).subscribe(resp => {
        this.cnsltnReq = resp.data.cnsltnReq;

        if(this.cnsltnReq.isImpossible == 1){
          this.isImpossible = true;
        };
        
        this.fareService.getCnsltnMoveCntryRate({}, this.reqNo).subscribe((crncyRateList:Array<CrncyRateModel>) => {
            this.crncyRateList = crncyRateList;
            _.uniq(this.crncyRateList);
            
            //소계, 합계 금액 화면 셋팅
            let seq = -1;
            this.initSubTotalDataList(this.orgCstSubTotal, "출발지", "", ++seq);
            this.initSubTotalDataList(this.transCstSubTotal, this.cnsltnReq.transTp == 0 ? '해상 운임':'항공 운임', "US", ++seq);
            this.initSubTotalDataList(this.desCstSubTotal, "도착지", "", ++seq);
            this.initSubTotalDataList(this.cstTotal, "총 운임", "KR", ++seq);
                  
            if(this.quotNo!=null) {
              this.cnsltnQuot = _.find(resp.data.cnsltnQuotLst, {quotNo: this.quotNo});

              if(this.cnsltnQuot){
                this.setDataToScreen(this.cnsltnQuot);
                this.tabIndex = 0;

                if(this.cnsltnQuot.linerNm && this.cnsltnQuot.linerCd){
                  this.onLineInput(this.cnsltnQuot.linerNm, this.cnsltnReq.transTp == 0 ? 'OCEAN':'AIR');   
                    if(this.filteredLineList.length > 0) this.selectLineListHandler(this.filteredLineList[0]);
                    else{
                      if(this.cnsltnReq.transTp == 0) this.selectLineListHandler({lineNm:this.cnsltnQuot.linerNm, linerCd:''});
                      else this.selectLineListHandler({name:this.cnsltnQuot.linerNm, linerCd:''});
                    }
                }else if(this.cnsltnQuot.linerNm && !this.cnsltnQuot.linerCd){
                  if(this.cnsltnReq.transTp == 0){
                    let oceanLine:OceanLine = new OceanLine();
                    oceanLine.lineNm = this.cnsltnQuot.linerNm;
                    this.selectedLine = oceanLine;
                  }else{
                    let airLine:AirLine = new AirLine();
                    airLine.name = this.cnsltnQuot.linerNm;
                    this.selectedLine = airLine;
                  }
                  this.cnsltnQuot.linerNm = this.cnsltnQuot.linerNm;
                  this.cnsltnQuot.linerCd = '';
                }
                
                if(this.cnsltnQuot.orgCrncyCd) this.setSubTotalDataList(0, this.cnsltnQuot.orgCrncyCd);
                if(this.cnsltnQuot.transCrncyCd) {
                  this.setSubTotalDataList(1, this.cnsltnQuot.transCrncyCd);
                }else{
                  this.setSubTotalDataList(1, 'USD');
                } 
                if(this.cnsltnQuot.desCrncyCd) this.setSubTotalDataList(2, this.cnsltnQuot.desCrncyCd);
                if(this.cnsltnQuot.totalCrncyCd) this.setSubTotalDataList(3, this.cnsltnQuot.totalCrncyCd); 
              }
              
              if(this.cnsltnQuot.stusCd != 0) this.isTempSave = false;
              
              //라우트 정보
              this.fareService.getQuotRouteList({quotNo:this.quotNo, reqNo:this.reqNo}).subscribe((cnsltnQuotRouteList:Array<CnsltnQuotRouteModel>) => {
                if(cnsltnQuotRouteList && cnsltnQuotRouteList.length > 0){
                  cnsltnQuotRouteList = _.map(cnsltnQuotRouteList, 
                    (cnsltnQuotRoute:CnsltnQuotRouteModel) => {
                      cnsltnQuotRoute.airLines = this.airLines;
                      cnsltnQuotRoute.oceanLines = this.oceanLines;
                      cnsltnQuotRoute.airports = this.airports;
                      cnsltnQuotRoute.ports = this.ports;
                      cnsltnQuotRoute.countries = this.countries;

                      return cnsltnQuotRoute; 
                    }
                  );
                  cnsltnQuotRouteList = _.sortBy(cnsltnQuotRouteList,
                                                (cnsltnQuotRoute:CnsltnQuotRouteModel) => {
                                                  return cnsltnQuotRoute.seq;
                                        });
                  this.fareRateRoute.receivedRouteData(cnsltnQuotRouteList);    
                }      
              }); 
            }
            
            //단위 생성
            this.itemUnitList = new Array();
            if(this.cnsltnReq.transTp == 0 && this.cnsltnReq.reqTp == 0){
              //FCL 
              this.itemUnitList.push({id: 'bl', name:"B/L"});
              this.itemUnitList.push({id: 'cntr', name:"CNTR"});
              // this.itemUnitList.push({id: 'cbm', name:"CBM"});
            }else if(this.cnsltnReq.transTp == 0 && this.cnsltnReq.reqTp == 1){
              //LCL
              this.itemUnitList.push({id: 'bl', name:"B/L"});
              this.itemUnitList.push({id: 'cbm', name:"CBM"});
              // this.itemUnitList.push({id: 'kg', name:"KG"});
            }else if(this.cnsltnReq.transTp == 1){
              //AIR
              this.itemUnitList.push({id: 'awb', name:"AWB"});
              this.itemUnitList.push({id: 'kg', name:"KG"});
            }

            // this.loadingService.isClose = true;
            this.isSearching = false;
          }
        );
      }
    );

    this.availDtOptions = new DatePickerOptions({
      format: 'YYYYMMDD',
      initialDate: new Date(),
      autoApply: true,
      minDate: new Date(),
      maxDate: new Date('')
    });
    this.wrtDtOptions = new DatePickerOptions({
      format: 'YYYYMMDD',
      initialDate: new Date(),
      autoApply: true
    });

    let availDateModel:DateModel = new DateModel();
    let availMomentObj = moment(Util.todayFormatDate(), "YYYYMMDD");
    availDateModel.momentObj = availMomentObj;
    availDateModel.formatted = Util.todayFormatDate();
    this.availDt = availDateModel;
  
    let wrtDateModel:DateModel = new DateModel();
    let wrtMomentObj = moment(Util.todayFormatDate(), "YYYYMMDD");
    wrtDateModel.momentObj = wrtMomentObj;
    wrtDateModel.formatted = Util.todayFormatDate();
    this.wrtDt = wrtDateModel;

    //달력 설정
    this.subs.add(consult);
  }
  
  goNgOnInit(){

    this.route.params.subscribe(params => {
       this.reqNo = params['id'];
       this.quotNo = params['id2'];
    });

    //CostItem 조회
    this.fareService.getCostItem().subscribe((costItemList:Array<CostItemModel>) => {
      this.costItemList = costItemList;
    });

    //통화, 비용 조회
    this.fareService.getCnsltnMoveCntryRate({}, this.reqNo).subscribe((crncyRateList:Array<CrncyRateModel>) => {
      this.crncyRateList = crncyRateList;
      //소계, 합계 금액 화면 셋팅
      let seq = -1;
      this.initSubTotalDataList(this.orgCstSubTotal, "출발지", "", ++seq);
      this.initSubTotalDataList(this.transCstSubTotal, this.cnsltnReq.transTp == 0 ? '해상 운임':'항공 운임', "US", ++seq);
      this.initSubTotalDataList(this.desCstSubTotal, "도착지", "", ++seq);
      this.initSubTotalDataList(this.cstTotal, "총 운임", "KR", ++seq);

      this.isSearching = true;

      if(this.quotNo){
        this.fareService.getQuotation({quotNo:this.quotNo, reqNo:this.reqNo}).subscribe((cnsltnQuot:CnsltnQuotModel) => {
          this.isSearching = false;
          if(cnsltnQuot){
            this.setDataToScreen(cnsltnQuot);
            this.tabIndex = 0;
            if(cnsltnQuot.linerNm && cnsltnQuot.linerCd){
              this.onLineInput(cnsltnQuot.linerNm, this.cnsltnReq.transTp == 0 ? 'OCEAN':'AIR');   
                if(this.filteredLineList.length > 0) this.selectLineListHandler(this.filteredLineList[0]);
                else{
                  if(this.cnsltnReq.transTp == 0) this.selectLineListHandler({lineNm:cnsltnQuot.linerNm, linerCd:''});
                  else this.selectLineListHandler({name:cnsltnQuot.linerNm, linerCd:''});
                }
            }else if(cnsltnQuot.linerNm && !cnsltnQuot.linerCd){
              if(this.cnsltnReq.transTp == 0){
                let oceanLine:OceanLine = new OceanLine();
                oceanLine.lineNm = cnsltnQuot.linerNm;
                this.selectedLine = oceanLine;
              }else{
                let airLine:AirLine = new AirLine();
                airLine.name = cnsltnQuot.linerNm;
                this.selectedLine = airLine;
              }
              this.cnsltnQuot.linerNm = cnsltnQuot.linerNm;
              this.cnsltnQuot.linerCd = '';
              //this.transCstSubTotal.fareTypNm = cnsltnQuot.linerNm;
            }
            if(cnsltnQuot.orgCrncyCd) this.setSubTotalDataList(0, cnsltnQuot.orgCrncyCd);
            if(cnsltnQuot.transCrncyCd) {
              this.setSubTotalDataList(1, cnsltnQuot.transCrncyCd);
            }else{
              this.setSubTotalDataList(1, 'USD');
            } 
            if(cnsltnQuot.desCrncyCd) this.setSubTotalDataList(2, cnsltnQuot.desCrncyCd);
            if(cnsltnQuot.totalCrncyCd) this.setSubTotalDataList(3, cnsltnQuot.totalCrncyCd);
          
            this.cnsltnQuot = cnsltnQuot;
          }
          
          if(cnsltnQuot.stusCd != 0) this.isTempSave = false;
        });

        //라우트 정보
        this.fareService.getQuotRouteList({quotNo:this.quotNo, reqNo:this.reqNo}).subscribe((cnsltnQuotRouteList:Array<CnsltnQuotRouteModel>) => {
          if(cnsltnQuotRouteList && cnsltnQuotRouteList.length > 0){
            cnsltnQuotRouteList = _.map(cnsltnQuotRouteList, 
              (cnsltnQuotRoute:CnsltnQuotRouteModel) => {
                cnsltnQuotRoute.airLines = this.airLines;
                cnsltnQuotRoute.oceanLines = this.oceanLines;
                cnsltnQuotRoute.airports = this.airports;
                cnsltnQuotRoute.ports = this.ports;
                cnsltnQuotRoute.countries = this.countries;

                return cnsltnQuotRoute; 
              }
            );
            cnsltnQuotRouteList = _.sortBy(cnsltnQuotRouteList,
                                          (cnsltnQuotRoute:CnsltnQuotRouteModel) => {
                                            return cnsltnQuotRoute.seq;
                                  });
            this.fareRateRoute.receivedRouteData(cnsltnQuotRouteList);    
          }      
        });
      }
    });

    // this.oceanLines = this.oceanLineService.lineList;
		// this.oceanLineService.lineListEe.subscribe(
		//   oceanLines => {
		// 	this.oceanLines = oceanLines;
		//   }
		// );

		// this.airLines = this.airLineService.lineList;
		// this.airLineService.lineListEe.subscribe(
		// 	airLines => {
		// 	  this.airLines = airLines;
		//   }
		// );
  
    //견적 요청 정보
    this.fareService.getCnsltnReq({}, this.reqNo).subscribe((cnsltnReq:CnsltnReqModel) => {
      this.cnsltnReq = cnsltnReq;

      //단위 생성
      this.itemUnitList = new Array();
      if(this.cnsltnReq.transTp == 0 && this.cnsltnReq.reqTp == 0){
        //FCL 
        this.itemUnitList.push({id: 'bl', name:"B/L"});
        this.itemUnitList.push({id: 'cntr', name:"CNTR"});
        // this.itemUnitList.push({id: 'cbm', name:"CBM"});
      }else if(this.cnsltnReq.transTp == 0 && this.cnsltnReq.reqTp == 1){
        //LCL
        this.itemUnitList.push({id: 'bl', name:"B/L"});
        this.itemUnitList.push({id: 'cbm', name:"CBM"});
        // this.itemUnitList.push({id: 'kg', name:"KG"});
      }else if(this.cnsltnReq.transTp == 1){
        //AIR
        this.itemUnitList.push({id: 'awb', name:"AWB"});
        this.itemUnitList.push({id: 'kg', name:"KG"});
      }
    });

    //달력 설정
    this.availDtOptions = new DatePickerOptions({
      format: 'YYYYMMDD',
      initialDate: new Date(),
      autoApply: true,
      minDate: new Date(),
      maxDate: new Date('')
    });
    this.wrtDtOptions = new DatePickerOptions({
      format: 'YYYYMMDD',
      initialDate: new Date(),
      autoApply: true
    });

    let date = new Date();    
    let availDateModel:DateModel = new DateModel();
    let availMomentObj = moment(Util.todayFormatDate(), "YYYYMMDD");
    availDateModel.momentObj = availMomentObj;
    availDateModel.formatted = Util.todayFormatDate();
    this.availDt = availDateModel;
  
    let wrtDateModel:DateModel = new DateModel();
    let wrtMomentObj = moment(Util.todayFormatDate(), "YYYYMMDD");
    wrtDateModel.momentObj = wrtMomentObj;
    wrtDateModel.formatted = Util.todayFormatDate();
    this.wrtDt = wrtDateModel;

    // this.cnsltnQuot.linerNm = "운임 비용";
  }

  ngOnInit() {
    this.setAllList();
  }

  setSubTotalDataList(index:number, crncyCd:string){
    this.crncyRateList.map((crncyRate:CrncyRateModel)=>{
      if(crncyRate.crncyCd.indexOf(crncyCd) > -1){
        this.fareRateSum.refreshValue({id:crncyRate.crncyCd, text:crncyRate.crncyCd}, index);
        return ;
      }
    });
  }

  initSubTotalDataList(cstSubTotal:CstSubTotalModel, typeNm:string, defaultCntryCd:string, seq:number){
    cstSubTotal.fareTypNm = typeNm;
    // cstSubTotal.crncyRateList = this.crncyRateList;
    cstSubTotal.totalCost = 0;

    if(defaultCntryCd == "" && typeNm.indexOf("출발지") > -1){
      defaultCntryCd = this.cnsltnReq.orgCntryCd;
    }else if(defaultCntryCd == "" && typeNm.indexOf("도착지") > -1){
      defaultCntryCd = this.cnsltnReq.desCntryCd;
    }

    let stndDt = "";
    let isExistCrncy = false;
    let subTotalCrncy: CrncyRateModel = null;
    this.crncyRateList.map((crncyRate:CrncyRateModel)=>{
      if(crncyRate.cntryCd.indexOf(defaultCntryCd) > -1){
        isExistCrncy = true;
        subTotalCrncy = crncyRate;
        cstSubTotal.cntryCd = crncyRate.cntryCd;
        cstSubTotal.stndDt = crncyRate.stndDt;
        cstSubTotal.crncyCd = crncyRate.crncyCd;
        stndDt = crncyRate.stndDt;
      }

      if(!isExistCrncy){
        if(crncyRate.crncyCd.indexOf("USD") > -1){
          isExistCrncy = true;
          subTotalCrncy = crncyRate;
          cstSubTotal.cntryCd = crncyRate.cntryCd;
          cstSubTotal.stndDt = crncyRate.stndDt;
          cstSubTotal.crncyCd = crncyRate.crncyCd;
          stndDt = crncyRate.stndDt;
        }
      }
    }); 
    
    if (subTotalCrncy) {
      let krwPerUnit = new bigdecimal.BigDecimal(subTotalCrncy.krwPerUnit);
      cstSubTotal.temp = "기준환율 : " + krwPerUnit.setScale(2, bigdecimal.RoundingMode.DOWN()).doubleValue() 
      + " KRW (기준일 : " + Util.dateFomatter(stndDt)+")"; 
    }
    
    this.cstSubTotalList.push(cstSubTotal);
  }

  ngOnDestroy(){
		if(this.countryListEeSub) this.countryListEeSub.unsubscribe();
		if(this.airportListEeSub) this.airportListEeSub.unsubscribe();
		if(this.portListEeSub) this.portListEeSub.unsubscribe();
    if(this.oceanLineListEeSub) this.oceanLineListEeSub.unsubscribe();
    if(this.airLineListEeSub) this.airLineListEeSub.unsubscribe();
    if(this.subs) this.subs.unsubscribe();
  }

  temporarySave(){
    this.quotaCstSave("TEMPORARY");
  }

  quotationSubmit(){
    this.quotaCstSave("REAL"); 
  }

  chkWharfage(data:any){
    if(this.cnsltnReq.transTp == 0 && this.cnsltnReq.reqTp == 1 && data.itemNm.toLowerCase().indexOf('wharfage') > -1){
      if((data.chargeWm && data.chargeWm % 1 > 0) || (!data.chargeWm && data.tempChargeWm && data.tempChargeWm % 1 > 0)){
        this.alertService.error("항목 Wharfage의 수량은 소수점 자리를 입력하실 수 없습니다. 다시 입력해주세요.");
        return false;
      }
    }
    return true;
  }

  quotaCstSave(saveType:string){

    //최종견적 통화 저장
    this.cstSubTotalList.map((cstSubTotal:CstSubTotalModel)=>{

      if(cstSubTotal.fareTypNm.indexOf('출발지') > -1) { this.cnsltnQuot.orgCrncyCd = cstSubTotal.crncyCd}
      else if(cstSubTotal.fareTypNm.indexOf('해상 운임') > -1 || cstSubTotal.fareTypNm.indexOf('항공 운임') > -1){ this.cnsltnQuot.transCrncyCd = cstSubTotal.crncyCd}
      else if(cstSubTotal.fareTypNm.indexOf('도착지') > -1){ this.cnsltnQuot.desCrncyCd = cstSubTotal.crncyCd}
      else if(cstSubTotal.fareTypNm.indexOf('총 운임') > -1){ this.cnsltnQuot.totalCrncyCd = cstSubTotal.crncyCd}
    });
    
    //Route
    let routeList = Array<RouteModel>();
    
    this.fareRateRoute.cnsltnQuotRouteList.map((cnsltnQuotRoute:CnsltnQuotRouteModel) =>{
      let routeModel = new RouteModel();
      routeModel.linerCd = cnsltnQuotRoute.linerCd;
      routeModel.linerNm = cnsltnQuotRoute.linerNm;
      routeModel.locationAdrs = cnsltnQuotRoute.locationAdrs;
      routeModel.modeCd = cnsltnQuotRoute.modeCd;
      routeModel.quotNo = cnsltnQuotRoute.quotNo;
      routeModel.routeId = cnsltnQuotRoute.routeId;
      routeModel.seq = cnsltnQuotRoute.seq;
      routeModel.typeCd = cnsltnQuotRoute.typeCd;
      routeModel.modeNm = cnsltnQuotRoute.modeNm;
      routeModel.cntryCd = cnsltnQuotRoute.location.cntryCd;

      let location = new Location();
      location.locationId = cnsltnQuotRoute.location.locationId;
      routeModel.location = location;
      routeModel.latitude = cnsltnQuotRoute.latitude;
      routeModel.longitude = cnsltnQuotRoute.longitude;

      routeList.push(routeModel);
    })

    this.cnsltnQuot.reqNo = this.reqNo;

    if(!this.cnsltnOrgQuotCstList && this.cnsltnOrgQuotCstList.length > 0 && this.cnsltnOrgQuotCstList[0].crncyCd){
      this.cnsltnQuot.orgCrncyCd = this.cnsltnOrgQuotCstList[0].crncyCd;
    }

    if(!this.cnsltnDesQuotCstList && this.cnsltnDesQuotCstList.length > 0 && this.cnsltnDesQuotCstList[0].crncyCd){
      this.cnsltnQuot.desCrncyCd = this.cnsltnDesQuotCstList[0].crncyCd;
    }
    
    if(saveType.indexOf("TEMPORARY") > -1) this.cnsltnQuot.stusCd = 0;
    else this.cnsltnQuot.stusCd = 1;
    
    if(this.cnsltnReq.transTp == 0 && this.cnsltnReq.reqTp == 0){
      this.cnsltnQuot.quotTp = 0;
    }else if(this.cnsltnReq.transTp == 0 && this.cnsltnReq.reqTp == 1){
      this.cnsltnQuot.quotTp = 1;
    }else if(this.cnsltnReq.transTp == 1 && this.cnsltnReq.reqTp == 1){
      this.cnsltnQuot.quotTp = 2;
    }   

    this.cnsltnQuot.wrtDt = this.wrtDt ? this.wrtDt.formatted :  null;
    this.cnsltnQuot.quotStndWght = -1;
    this.cnsltnQuot.availDt = this.availDt ? this.availDt.formatted : null;

    this.cnsltnQuot.cstLst = new Array<any>();
    
    let isChkWharfage = false;
    this.cnsltnOrgQuotCstList.map((data:CnsltnQuotCstModel)=>{
      if(!this.chkWharfage(data)) return false; 
      else isChkWharfage = true;
      this.cnsltnQuot.cstLst.push(data.getCnsltnQuotSaveData());
    });

    this.cnsltnTransQuotCstList.map((data:CnsltnQuotCstModel)=>{
      if(!this.chkWharfage(data)) return false; 
      else isChkWharfage = true;
      this.cnsltnQuot.cstLst.push(data.getCnsltnQuotSaveData());
    });

    this.cnsltnDesQuotCstList.map((data:CnsltnQuotCstModel)=>{
      if(!this.chkWharfage(data)) return false; 
      else isChkWharfage = true;
      this.cnsltnQuot.cstLst.push(data.getCnsltnQuotSaveData());
    });

    // if(!isChkWharfage) return false;

    let isPossibleSave = true;
    let problemColumnNm = "";
    let problemColumnIndex = 0;
    
    //validation check
    if(saveType.indexOf("REAL") > -1){
     
      for(let i=0;i<routeList.length;i++){
        let routeModel:RouteModel = routeList[i];

        if(routeModel.typeCd == null){
          this.alertService.error(i +" 번 째 Type Code가 존재하지 않습니다. \n새로고침(F8)번을 눌러서 다시 시도해주세요.");
          return;
        }
        
        if(routeModel.typeCd != NodeType.DOOR && (!routeModel.location || !routeModel.location.locationId)){
          let typeNm = "";
          if(routeModel.typeCd == NodeType.AIRPORT) typeNm = "항공";
          else if(routeModel.typeCd == NodeType.PORT) typeNm = "항만";
          
          this.alertService.error(i+1 +" 번 째 " + typeNm + " 입력란이 잘못 되었습니다.\n 다시 입력해주세요.");
          return;
        }

        if(routeModel.typeCd == NodeType.DOOR && !routeModel.locationAdrs){
          this.alertService.error(i+1 +" 번 째 상세주소 입력란이 잘못 되었습니다. \n 다시 입력해주세요.");
          return;
        }

      }

      for(let i=0;i<this.cnsltnQuot.cstLst.length;i++){
        if(!this.cnsltnQuot.cstLst[i].itemCd || this.cnsltnQuot.cstLst[i].itemCd.length < 1 || !this.cnsltnQuot.cstLst[i].itemNm || this.cnsltnQuot.cstLst[i].itemNm.length < 1) {
          isPossibleSave = false;
          problemColumnIndex = i+1;
          problemColumnNm = "항목";
          break;
        }
        if(!this.cnsltnQuot.cstLst[i].crncyCd || this.cnsltnQuot.cstLst[i].crncyCd.length < 1){
          isPossibleSave = false;
          problemColumnNm = "통화";
          problemColumnIndex = i+1;
          break;
        }
        if(!this.cnsltnQuot.cstLst[i].itemUnit || this.cnsltnQuot.cstLst[i].itemUnit.length < 1){
          isPossibleSave = false;
          problemColumnNm = "단위";
          problemColumnIndex = i+1;
          break;
        }
        if(!this.cnsltnQuot.cstLst[i].unitCost && this.cnsltnQuot.cstLst[i].unitCost != 0){
          isPossibleSave = false;
          problemColumnNm = "단가";
          problemColumnIndex = i+1;
          break;
        }
      }

      if(this.cnsltnQuot.fwdrCorpId == null || !this.cnsltnQuot.forwarder || this.cnsltnQuot.forwarder.length <= 0){
        this.alertService.error("포워더에 값이 존재하지 않습니다. 포워더를 확인해주세요. ");
        return false;
      }
      if(!this.cnsltnQuot.person || this.cnsltnQuot.person.length <= 0){
        this.alertService.error("포워더 담당자에 값이 존재하지 않습니다. 포워더 담당자 부분을 확인해주세요. ");
        return false;
      }
      if(!this.cnsltnQuot.linerNm || this.cnsltnQuot.linerNm.length <= 0){
        let transTpNm = "선사";
        if(this.cnsltnReq.transTp == 1) transTpNm = "편명";
        
        this.alertService.error(transTpNm+"에 값이 존재하지 않습니다. 다시 한 번 확인해주세요. ");
        return false;
      }
      if(!this.cnsltnQuot.exptDys){
        this.alertService.error("소요 기간에 값이 존재하지 않습니다. 소요 기간을 확인해주세요. ");
        return false;
      }
      if(!this.cnsltnQuot.wrtDt || this.cnsltnQuot.wrtDt.length <= 0){
        this.alertService.error("견적 작성일이 존재하지 않습니다. 견적 작성일을 등록해주세요.");
        return false;
      }
      if(!this.cnsltnQuot.availDt || this.cnsltnQuot.availDt.length <= 0){
        this.alertService.error("견적 유효기간이 존재하지 않습니다. 견적 유효기간을 등록해주세요.");
        return false;
      }
    }

    if(!isPossibleSave){
      this.alertService.error(problemColumnNm+"에 값이 존재하지 않습니다. \n        " + problemColumnIndex + "번 째 항목을 확인해주세요.");
      return false;
    }

    this.isSave = true;
    this.fareService.postCnsltnQuot({cnsltnQuot:this.cnsltnQuot, routeList:routeList}).subscribe((data:any)=>{
      if(data != null && data.result.indexOf("success") > -1){
        this.router.navigate(['/quotation/consult-detail', this.reqNo]);
      }
      this.isSave = false;
    });
  }

  fileChange(e){
    if(e != undefined) {
      var file = e.target.files[0];
      if(file != null && file.size > 0) {
        this.excelService.readFile(file).subscribe(result => {
          this.makeFareExcelData(result.wb);
        });
      }
    }
  }

  makeFareExcelData(wb: IWorkBook) {

    let fwSheetArr:Array<IWorkSheet> = new Array<IWorkSheet>();
    wb.SheetNames.map((sheetName: string) => {
      if(sheetName.indexOf('FW') > -1){ fwSheetArr.push(wb.Sheets[sheetName]); }
    });
    
    let cstGrpList:Array<CstGrpModel> = new Array<CstGrpModel>();
    if(fwSheetArr.length > 0){
      fwSheetArr.map((sheet:IWorkSheet) => {
        cstGrpList = this.inputSheetToData(sheet, this.cnsltnQuot, this.transCstSubTotal, this.reqNo, this.cnsltnReq.transTp);

        if(!cstGrpList){ 
          this.alertService.error("견적서 요청 번호가 동일하지 않습니다. 파일에 요청 번호를 확인해주세요."); 
          return false; 
        }

        if(this.cnsltnQuot.linerNm){
          this.onLineInput(this.cnsltnQuot.linerNm, this.cnsltnReq.transTp == 0 ? 'OCEAN':'AIR');   
          
          if(this.filteredLineList.length > 0) this.selectLineListHandler(this.filteredLineList[0]);
          else{
            if(this.cnsltnReq.transTp == 0) this.selectLineListHandler({lineNm:this.cnsltnQuot.linerNm, linerCd:''});
            else this.selectLineListHandler({name:this.cnsltnQuot.linerNm, linerCd:''});
          } 
        }

        // if(this.cnsltnQuot.linerNm && this.cnsltnQuot.linerCd){
        //   this.onLineInput(this.cnsltnQuot.linerNm, this.cnsltnReq.transTp == 0 ? 'OCEAN':'AIR');   
        //     if(this.filteredLineList.length > 0) this.selectLineListHandler(this.filteredLineList[0]);
        //     else{
        //       if(this.cnsltnReq.transTp == 0) this.selectLineListHandler({lineNm:this.cnsltnQuot.linerNm, linerCd:''});
        //       else this.selectLineListHandler({name:this.cnsltnQuot.linerNm, linerCd:''});
        //     }
        // }else if(this.cnsltnQuot.linerNm && !this.cnsltnQuot.linerCd){
        //   if(this.cnsltnReq.transTp == 0){
        //     let oceanLine:OceanLine = new OceanLine();
        //     oceanLine.lineNm = this.cnsltnQuot.linerNm;
        //     this.selectedLine = oceanLine;
        //   }else{
        //     let airLine:AirLine = new AirLine();
        //     airLine.name = this.cnsltnQuot.linerNm;
        //     this.selectedLine = airLine;
        //   }
        // }

        if(this.cnsltnQuot.availDt){
          let availDateModel:DateModel = new DateModel();
          let availMomentObj = moment(this.cnsltnQuot.availDt, "YYYYMMDD");
          availDateModel.momentObj = availMomentObj;
          availDateModel.formatted = this.cnsltnQuot.availDt;
          this.availDt = availDateModel;
        }
      
        if(this.cnsltnQuot.wrtDt){
          let wrtDateModel:DateModel = new DateModel();
          let wrtMomentObj = moment(this.cnsltnQuot.wrtDt, "YYYYMMDD");
          wrtDateModel.momentObj = wrtMomentObj;
          wrtDateModel.formatted = this.cnsltnQuot.wrtDt;
          this.wrtDt = wrtDateModel;
        }
        this.convertDataToListFormat(cstGrpList);
      });
    }else{
      alert("파일 형식이 잘못되었습니다.");
      return false;
    }
  };
  
  convertDataToListFormat(cstGrpList:Array<CstGrpModel>){
    if (this.cnsltnReq.reqTp == 0) {
      let cstListList: Array<Array<CnsltnQuotCstModel>> = [
        this.cnsltnOrgQuotCstList,
        this.cnsltnDesQuotCstList,
        this.cnsltnTransQuotCstList
      ]
      for (let clI = 0 ; clI < cstListList.length ; clI++) {
        for (let cI = 0 ; cI < cstListList[clI].length ; cI++) {
          let cst:CnsltnQuotCstModel = cstListList[clI][cI];
          if (cst.crgoSeq == this.tabIndex || (this.tabIndex == 0 && !cst.crgoSeq)) {
            cstListList[clI].splice(cI, 1);
            cI--;
          }
        }
      }
    }

    for(var i=0; i<cstGrpList.length; i++){
      let cnsltnQuotCstListTemp: Array<CnsltnQuotCstModel> = new Array<CnsltnQuotCstModel>();
      
      cstGrpList[i].cstLst.map((cst:CstModel) =>{
        let cnsltnQuotCst = new CnsltnQuotCstModel(cstGrpList[i].cstTp, this.reqNo);
        cnsltnQuotCst.crncyCd = cst.crncyCd;
        cnsltnQuotCst.itemUnit = cst.itemUnit;
        cnsltnQuotCst.unitCost = cst.cost;

        this.costItemList.map((costItem:CostItemModel) => {
          if(costItem.itemNm.indexOf(cst.itemNm) > -1){
            cnsltnQuotCst.itemNm = cst.itemNm;
            cnsltnQuotCst.itemCd = costItem.itemCd;
            return;
          }
        });
        
        if (this.cnsltnReq.reqTp == 0 && cnsltnQuotCst.itemUnit != 'bl') cnsltnQuotCst.crgoSeq = this.tabIndex;
        
        if (!(this.tabIndex > 0 && cnsltnQuotCst.itemUnit == 'bl')) {
          cnsltnQuotCstListTemp.push(cnsltnQuotCst);
        }
      });

      if(0 == cstGrpList[i].cstTp){
        this.cnsltnOrgQuotCstList = this.cnsltnOrgQuotCstList.concat(cnsltnQuotCstListTemp);
      }else if(1 == cstGrpList[i].cstTp){
        this.cnsltnDesQuotCstList = this.cnsltnDesQuotCstList.concat(cnsltnQuotCstListTemp);
      }else if(2 == cstGrpList[i].cstTp || 3 == cstGrpList[i].cstTp){
        this.cnsltnTransQuotCstList = this.cnsltnTransQuotCstList.concat(cnsltnQuotCstListTemp);
      }
    }
  }

  sumCost(fareTypeNm: string, costList: CnsltnQuotCstModel[], targetCrncyCd: string,
    callback: (totalCost: number) => void,
    setCrncyCd:(costModel: CnsltnQuotCstModel, crncyCd: string) => void, getCost:(costModel: CnsltnQuotCstModel) => number, setCost:(costModel: CnsltnQuotCstModel, cost: number)=>void) {

    if (!callback) return;
    let totalCost: number = 0;
    let apiCallCnt: number = 0;
    let completeCnt: number = 0;
    let subList : Subscription[] = [];

    if (this.exchangeSubs.get(fareTypeNm)) this.exchangeSubs.get(fareTypeNm).forEach(subs => subs.unsubscribe());

    for (let cost of costList) {
      setCrncyCd(cost, targetCrncyCd);
      if (getCost(cost)) totalCost += getCost(cost);
      else if (cost.cost) apiCallCnt++;
    }

    if (apiCallCnt <= 0) {
      callback(totalCost);
      return;
    }

    for (let cost of costList) {
      if (!cost.cost || getCost(cost)) continue;
      let subs = this.currencyService.getExchange(
        cost.crncyCd, targetCrncyCd, cost.cost.doubleValue(),
        exchange => {
          totalCost += exchange.changedCost;
          setCost(cost, exchange.changedCost);
          completeCnt++;
          if (completeCnt == apiCallCnt) callback(totalCost);
        }
      );
      subList.push(subs);
    }

    this.exchangeSubs.set(fareTypeNm, subList);
  }


  sumTotalCost(fareTypeNm: string, costList: CnsltnQuotCstModel[], targetCrncyCd: string,  callback: (totalCost: number) => void) {
    this.sumCost(fareTypeNm, costList, targetCrncyCd, callback,
      (costModel: CnsltnQuotCstModel, crncyCd: string) => costModel.subTtlCrncyCd = crncyCd,
      (costModel: CnsltnQuotCstModel) => costModel.subTtlCost,
      (costModel: CnsltnQuotCstModel, cost: number) => costModel.subTtlCost = cost
      );
  }

  setTotalCost() {
    let costList = [];
    costList = costList.concat(this.cnsltnOrgQuotCstList);
    costList = costList.concat(this.cnsltnDesQuotCstList);
    costList = costList.concat(this.cnsltnTransQuotCstList);
    
    this.sumTotalCost('ALL', costList, this.cstTotal.crncyCd,
      totalCost => this.cstTotal.totalCost = totalCost
    );
  }
  
  totalListener(fareTypeNm:any){
    if(fareTypeNm == 'POL'){
      this.orgCstSubTotal.totalCost = 0;
      this.sumTotalCost('POL', this.cnsltnOrgQuotCstList, this.orgCstSubTotal.crncyCd,
        totalCost => {
          this.orgCstSubTotal.totalCost = totalCost;
        }
      );
    }else if(fareTypeNm == 'POD'){
      this.desCstSubTotal.totalCost = 0;
      this.sumTotalCost('POD', this.cnsltnDesQuotCstList, this.desCstSubTotal.crncyCd,
        totalCost => {
          this.desCstSubTotal.totalCost = totalCost;
        }
      );
    }else{
      this.transCstSubTotal.totalCost = 0;
      this.sumTotalCost('TRANS', this.cnsltnTransQuotCstList, this.transCstSubTotal.crncyCd,
        totalCost => {
          this.transCstSubTotal.totalCost = totalCost;
        }
      );
    }
    this.setTotalCost();
  }

  lineClick(event, type){
    let val = event.target.value;
    let lines:Array<any>;
    if(val){
      this.onLineInput(event, type);
    }else{
      if("OCEAN".indexOf(type) > -1){
        if(!this.oceanLines || this.oceanLines.length < 1){
          this.oceanLines = this.oceanLineService.lineList;
        }
        lines = this.oceanLines;
      }else{
        if(!this.airLines || this.airLines.length < 1){
            this.airLines = this.airLineService.lineList;
        }
        lines = this.airLines
      }
      
      this.filteredLineList = lines;
      this.isLineListOpen = true;
    }
  }

  onLineInput(event, type){
    let val = "";
    let lines:Array<any>;

    if("OCEAN".indexOf(type) > -1){
      if(!this.oceanLines || this.oceanLines.length < 1){
        this.oceanLines = this.oceanLineService.lineList;
      }
      lines = this.oceanLines;
    }else{
      if(!this.airLines || this.airLines.length < 1){
          this.airLines = this.airLineService.lineList;
      }
      lines = this.airLines
    }

    if(event.target) val = event.target.value;
    else val = event;

    if(!val){
      if (this.selectedLine) this.selectedLine = null;
      this.isLineListOpen = false;
    }else {
      this.isLineListOpen = true;
      let keyword = _.trim(_.upperCase(val));

      let fiteredLineList = [];
      fiteredLineList = _.map(_.filter(lines,
                (line:any) => {
                  let lineName = "";
                  let lineCode = "";
                  let iataCd = "";
                  if("OCEAN".indexOf(type) > -1){
                    lineName = line.lineNm;
                    lineCode = line.lineCd;
                  }else{
                    lineName = line.name;
                    lineCode = line.lineCd;
                    iataCd = line.iataCd;
                  }

                  if (keyword.length <= 0) return true;
                  else if (_.upperCase(lineName).indexOf(keyword) >= 0) return true;
                  else if (_.upperCase(lineCode).indexOf(keyword) >= 0) return true;
                  else if (iataCd && iataCd.length > 0 &&_.upperCase(iataCd).indexOf(keyword) >= 0) return true;
                  else return false;
                }));
      fiteredLineList = _.sortBy(fiteredLineList,
              (line:any) => {
              let lineName = "";
              let lineCode = "";
              if("OCEAN".indexOf(type) > -1){
                lineName = line.lineNm;
                lineCode = line.lineCd;
              }else{
                lineName = line.name;
                lineCode = line.iataCd;
              }
              let nmIndex = _.upperCase(lineName).indexOf(keyword);
              let cdIndex = _.upperCase(lineCode).indexOf(keyword);
              if (nmIndex < 0) nmIndex = 999;
              if (cdIndex < 0) cdIndex = 999;
              return _.min([nmIndex, cdIndex])
            });

      this.filteredLineList = fiteredLineList;
    }
    
    if(!val || val && val.trim().length < 1 || this.filteredLineList.length < 1){
      this.fareService.chnagedLiner({linerNm:val, flag:0});
    }
    
    this.cnsltnQuot.linerNm = val;
    this.cnsltnQuot.linerCd = '';
    //this.transCstSubTotal.fareTypNm = val;

    if(this.cnsltnReq.transTp == 0){
      let oceanLine:OceanLine = new OceanLine();
      oceanLine.lineNm = val;
      this.selectedLine = oceanLine;
    }else{
      let airLine:AirLine = new AirLine();
      airLine.name = val;
      this.selectedLine = airLine;
    }
  }

  handleKeyDown(event) {
    if (event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40 ) return;

    let suggestListItem = null;
    if (this.lineListRef) suggestListItem = this.lineListRef.nativeElement.querySelectorAll('li');

    switch (event.keyCode) {
        case 13: // enter
          let item = this.filteredLineList[this.focusedLineIndex];
          this.selectLineListHandler(item);
          this.isLineListOpen = false;  
          this.focusedLineIndex = 0;
          break;
        case 38: // up
            this.focusedLineIndex--;
            if (this.focusedLineIndex < 0) this.focusedLineIndex = 0;
            suggestListItem[this.focusedLineIndex].scrollIntoViewIfNeeded(true);
            break;
        case 40: // down
        this.focusedLineIndex++;
            if (this.focusedLineIndex > suggestListItem.length - 1) this.focusedLineIndex = suggestListItem.length - 1;
            suggestListItem[this.focusedLineIndex].scrollIntoViewIfNeeded(false);
             break;
        default: console.log("event.keyCode:", event.keyCode);return;
    }

    event.preventDefault();
  }

  handleBlur(event){
    if (this.isLineListOpen) this.isLineListOpen = false;

    if(this.cnsltnQuot.linerNm && this.cnsltnQuot.linerNm.length > 0){    
      if(this.cnsltnReq.transTp == 0){
        let line = _.find(this.oceanLines, (line:OceanLine) =>{
          if(_.upperCase(line.lineNm) == _.upperCase(this.cnsltnQuot.linerNm)) {
            return true;
          }
          if(_.upperCase(line.lineCd) == _.upperCase(this.cnsltnQuot.linerNm)) {
            return true;
          }
        });
        if(line){
          this.cnsltnQuot.linerCd = line.lineCd;
        }
      }else{
        let line = _.find(this.airLines, (line:AirLine) =>{
          if(_.upperCase(line.name) == _.upperCase(this.cnsltnQuot.linerNm)) {
            return true;
          }
          if(_.upperCase(line.iataCd) == _.upperCase(this.cnsltnQuot.linerNm)) {
            return true;
          }
        });
        if(line){
          this.cnsltnQuot.linerCd = line.iataCd;
        }
      }
    }
    this.fareService.chnagedLiner({linerNm:this.cnsltnQuot.linerNm, flag:0});
  }

  selectLineListHandler(line:any) {
    this.isLineListOpen = false;
    this.selectedLine = line;

    if(this.cnsltnReq.transTp == 0){
      this.cnsltnQuot.linerNm = line.lineNm;
      this.cnsltnQuot.linerCd = line.lineCd;
    }else {
      this.cnsltnQuot.linerNm = line.name;
      this.cnsltnQuot.linerCd = line.iataCd;
    }
    //this.transCstSubTotal.fareTypNm = this.cnsltnQuot.linerNm;

    this.fareService.chnagedLiner({linerNm:this.cnsltnQuot.linerNm, flag:1});

    let label = null;

    if(this.selectedLine) {
      if(this.cnsltnReq.transTp == 0) {
        label = '['+ this.selectedLine.lineCd + '] ' + this.selectedLine.lineNm;
      } else {
        label = '['+ this.selectedLine.iataCd + '] ' + this.selectedLine.name;
      }
    } else {
      label = null;
    };

    this.lineInput.setValue(label);
  }

  

  setDataToScreen(cnsltnQuot:CnsltnQuotModel){

    this.cnsltnQuot.forwarder = cnsltnQuot.forwarder;
    this.cnsltnQuot.person = cnsltnQuot.person;
    this.cnsltnQuot.linerNm = cnsltnQuot.linerNm;
    this.cnsltnQuot.transNm = cnsltnQuot.transNm;
    this.cnsltnQuot.exptDys = cnsltnQuot.exptDys;
    this.cnsltnQuot.quotNo = cnsltnQuot.quotNo;
    this.cnsltnQuot.srtSeq = cnsltnQuot.srtSeq;

    if(cnsltnQuot.availDt){
      let availDateModel:DateModel = new DateModel();
      let availMomentObj = moment(cnsltnQuot.availDt, "YYYYMMDD");
      availDateModel.momentObj = availMomentObj;
      availDateModel.formatted = cnsltnQuot.availDt;
      availDateModel.year = cnsltnQuot.availDt.substr(0,4);
      availDateModel.month = cnsltnQuot.availDt.substr(5,7);
      availDateModel.day = cnsltnQuot.availDt.substr(6,8);
      this.availDt = availDateModel;
    }

    console.log(cnsltnQuot.wrtDt);
    if(cnsltnQuot.wrtDt){
      let wrtDateModel:DateModel = new DateModel();
      let wrtMomentObj = moment(cnsltnQuot.wrtDt, "YYYYMMDD");
      wrtDateModel.momentObj = wrtMomentObj;
      wrtDateModel.formatted = cnsltnQuot.wrtDt;
      wrtDateModel.year = cnsltnQuot.wrtDt.substr(0,4);
      wrtDateModel.month = cnsltnQuot.wrtDt.substr(5,7);
      wrtDateModel.day = cnsltnQuot.wrtDt.substr(6,8);
      this.wrtDt = wrtDateModel;
    }

    let tempCnsltnOrgQuotCstList: Array<CnsltnQuotCstModel> = new Array<CnsltnQuotCstModel>();
    let tempCnsltnDesQuotCstList: Array<CnsltnQuotCstModel> = new Array<CnsltnQuotCstModel>();
    let tempCnsltnTransQuotCstList: Array<CnsltnQuotCstModel> = new Array<CnsltnQuotCstModel>();

    if(cnsltnQuot.cstLst){
      cnsltnQuot.cstLst.map((cnsltnQuotCst:CnsltnQuotCstModel)=>{
        let tempCnsltnQuotCst = new CnsltnQuotCstModel(cnsltnQuotCst.cstTp, this.reqNo);
        tempCnsltnQuotCst.crncyCd = cnsltnQuotCst.crncyCd;
        tempCnsltnQuotCst.itemUnit = cnsltnQuotCst.itemUnit;
        tempCnsltnQuotCst.unitCost = cnsltnQuotCst.unitCost;
        tempCnsltnQuotCst.quotCstId = cnsltnQuotCst.quotCstId;
        tempCnsltnQuotCst.crgoSeq = cnsltnQuotCst.crgoSeq;
        tempCnsltnQuotCst.chargeWm = cnsltnQuotCst.chargeWm;
        tempCnsltnQuotCst.minUnitCost = cnsltnQuotCst.minUnitCost;


        this.costItemList.map((costItem:CostItemModel) => {
          if(costItem.itemNm.indexOf(cnsltnQuotCst.itemNm) > -1){
            tempCnsltnQuotCst.itemNm = cnsltnQuotCst.itemNm;
            tempCnsltnQuotCst.itemCd = costItem.itemCd;
            return;
            }
          });
          
          if(cnsltnQuotCst.cstTp == 0){
            tempCnsltnOrgQuotCstList.push(tempCnsltnQuotCst);
          }else if(cnsltnQuotCst.cstTp == 1){
            tempCnsltnDesQuotCstList.push(tempCnsltnQuotCst);
          }else{
            tempCnsltnTransQuotCstList.push(tempCnsltnQuotCst);
          }
      });
    }
    

    this.cnsltnOrgQuotCstList = tempCnsltnOrgQuotCstList;
    this.cnsltnDesQuotCstList = tempCnsltnDesQuotCstList;
    this.cnsltnTransQuotCstList = tempCnsltnTransQuotCstList;

    this.setTotalCost();
  }

  ngAfterViewInit(){

    function storeTabs($tabs, $destination) {
      $tabs.each(function() {
          var width = $(this).outerWidth(true);
          $(this).data('width', width);
      });
      $tabs.prependTo($destination);
    }	
    function makeTabsResponsive($element) {
      
      var $tabs = $element.find('li');
      var $firstTab = $tabs.first();

      var individualTabHeight = $firstTab.outerHeight();
      var tabsHeight = $element.outerHeight();

      if (tabsHeight > individualTabHeight) {

          var firstTabPos = $firstTab.offset();

          var thisTabPos;
          $tabs.each(function() {
              var $thisTab = $(this);
              thisTabPos = $thisTab.offset();
              if (thisTabPos.top > firstTabPos.top) {

                  var $dropdown = $element.find('.responsivetabs-more');

                  if (!$dropdown.length) {
                      var dropdownMarkup = '<li class="dropdown responsivetabs-more">' + '<a href="#" class="dropdown-toggle" data-toggle="dropdown">...</a>' + '<ul class="dropdown-menu dropdown-menu-right">' + '</ul>';
                      $dropdown = $(dropdownMarkup);
                      $element.append($dropdown);
                  }

                  var $previousTab = $thisTab.prev();
                  var $followingTabs = $thisTab.nextAll().not('.dropdown');

                  var $destination = $('.dropdown-menu', $dropdown);

                  if (!$thisTab.hasClass('dropdown')) {
                      storeTabs($followingTabs, $destination);
                      storeTabs($thisTab, $destination);
                  }
                  storeTabs($previousTab, $destination);
                  return;
              }
          });
      } else {
          var parentWidth = $element.parent().width();
          var tabSetWidth = 0;
          var xPxAvailable;

          $element.children('li').each(function() {
              tabSetWidth += $(this).outerWidth(true);
          });

          xPxAvailable = parentWidth - tabSetWidth;

          $element.find('.dropdown-menu li').each(function() {
              if ($(this).data('width') <= xPxAvailable) {
                  $(this).insertBefore($element.find('.responsivetabs-more'));
                  xPxAvailable -= $(this).data('width');
              } else {
                  return false;
              }
          });

          if (!$element.find('.dropdown-menu li').length) {
              $element.find('.responsivetabs-more').remove();
          }
      }
    }

    $.fn.responsiveTabs = function() {
        this.each(function() {
            var tabs = $(this);
            makeTabsResponsive(tabs);
            $(window).resize(function() {
                makeTabsResponsive(tabs);
            });
        });
        return this;
    };

    $('.nav-tabs').responsiveTabs();
    // Input
		$(".material input").val("");
		
  }

  setTab(index) {
    this.tabIndex = index;
  }



  inputSheetToData(sheet:IWorkSheet, cnsltnQuot:CnsltnQuotModel, transCstSubTotal:CstSubTotalModel, thisReqNo:string, transTp:number):Array<CstGrpModel>{
    if(thisReqNo.indexOf(this.getExValue(sheet['B3']).substr(1)) == -1){return ;}
    var sheetNm = this.getExValue(sheet['B2']);
    var quotTp = -1;
    var quotTpNm = '';
    if (sheetNm.indexOf('FCL') >= 0) {
      quotTp = 0;
      quotTpNm = 'FCL Sea';
    }
    else if (sheetNm.indexOf('LCL') >= 0 && sheetNm.indexOf('Sea') >= 0) {
      quotTp = 1;
      quotTpNm = 'LCL Sea';
    }
    else if (sheetNm.indexOf('LCL') >= 0 && sheetNm.indexOf('Air') >= 0) {
      quotTp = 2;
      quotTpNm = 'LCL Air';
    }
    
    /*
     * 헤더값 설정
     */
    //견적서 작성자 값
    var reqNo = this.getExValue(sheet['B3']).substr(1);
    var forwarder = this.getExValue(sheet['C4']);
    var person = this.getExValue(sheet['C5']);
    var wrtDt = this.getExValue(sheet['C6']);
    var availDt = this.getExValue(sheet['C7']);
  
    var quotStndWght = -1;
    var liner = '';
    var transNm = '';
    var exptDys = -1;
    
  
    if (quotTp === 0) {
      liner = this.getExValue(sheet['G4']);
      transNm = this.getExValue(sheet['G5']);
      exptDys = this.getExValue(sheet['G6']);
    } else {
      quotStndWght = this.getExValue(sheet['F6']);
      exptDys = this.getExValue(sheet['F7']);
      liner = this.getExValue(sheet['H4']);
      transNm = this.getExValue(sheet['H5']);
    }
    cnsltnQuot.forwarder = forwarder;
    cnsltnQuot.linerNm = liner;
    cnsltnQuot.transNm = transNm;
    cnsltnQuot.exptDys = exptDys;
    cnsltnQuot.person = person;
    
    transCstSubTotal.fareTypNm = transTp == 0 ? '해상 운임' : '항공 운임'
  
    cnsltnQuot.availDt = availDt;
    cnsltnQuot.wrtDt = wrtDt;
  
    //출발지, 고정, 도착지 통화 설정
    var orgCrncyCd = this.getExValue(sheet['D9']);
    var transCrncyCd = this.getExValue(sheet['E9']);
    var desCrncyCd = this.getExValue(sheet['F9']);
  
    //엑셀 값을 담는다.
    var cstGrpLst:Array<CstGrpModel> = new Array<CstGrpModel>();
    var cstGrpIdx = 0;
  
    //row 10부터 시작
    let isExistRow = true;
    let row = 9; 
    while(isExistRow){
      row++;
      //총계 종료
      if (this.getExValue(sheet['B' + row]).replace(/\s/g, '').indexOf('총계') >= 0){
        isExistRow = false;
        break;
      } 
      
      //그룹 별 셋팅
      if (this.getExValue(sheet['C' + row]).replace(/\s/g, '').indexOf('소계') >= 0) {
        cstGrpIdx++;
        continue;
      }
  
      if (!cstGrpLst[cstGrpIdx]) cstGrpLst[cstGrpIdx] = new CstGrpModel();
  
      if (sheet['B' + row]) {
        var cstTpNm = this.getExValue(sheet['B' + row]);
        // 비용 구분(0-출발지 비용, 1-도착지 비용, 2-해상 비용)
        if (cstTpNm.indexOf('출발') >= 0) {
          cstGrpLst[cstGrpIdx].cstTp = 0;
          cstGrpLst[cstGrpIdx].cstTpNm = 'POL';
        } else if (cstTpNm.indexOf('도착') >= 0) {
          cstGrpLst[cstGrpIdx].cstTp = 1;
          cstGrpLst[cstGrpIdx].cstTpNm = 'POD';
        } else if (cstTpNm.indexOf('해상') >= 0) {
          cstGrpLst[cstGrpIdx].cstTp = 2;
          cstGrpLst[cstGrpIdx].cstTpNm = '해상';
        } else if (cstTpNm.indexOf('항공') >= 0) {
          cstGrpLst[cstGrpIdx].cstTp = 3;
          cstGrpLst[cstGrpIdx].cstTpNm = '항공';
        }
      }
  
      //그룹 별 내용 
      var itemNm = this.getExValue(sheet['C' + row]);
      var itemUnit = this.getExValue(sheet['G' + row]).replace("/","").toLowerCase();
      var other = this.getExValue(sheet['H' + row]);
      var cost = null;
      var crncyCd = null;
  
      for (var colIdx = 0 ; colIdx < 3 ; colIdx++) {
        var colPrefix = 'D';
        if (colIdx === 1) colPrefix = 'E';
        else if (colIdx === 2) colPrefix = 'F';
  
        if (sheet[colPrefix + row]) {
          cost = this.getExValue(sheet[colPrefix + row]);
          if (colIdx === 0) crncyCd = orgCrncyCd;
          else if (colIdx === 1) crncyCd = transCrncyCd;
          else crncyCd = desCrncyCd;
          break;
        }
      }
      if (cost && Number(cost) > 0) cstGrpLst[cstGrpIdx].cstLst.push(new CstModel(itemNm, cost, crncyCd, itemUnit, other));
    }
    return cstGrpLst;
  }

  inputTransNm(){
    this.fareService.changeTransNmEmit.emit(this.cnsltnQuot.transNm);
  }
  

  getExValue(cell) {
    if (!cell) return '';
    else {
      if (cell.t === 's' ) return cell.v.trim();
      else return cell.v;
    }
  }

  selecedFwdr(event:Corporation){
    if(event){
      this.cnsltnQuot.fwdrCorpId = event.corpId;
      this.cnsltnQuot.forwarder = event.corpNm;
    }else{
      this.cnsltnQuot.fwdrCorpId = null;
      this.cnsltnQuot.forwarder = null;
    }
  }


  changeCrncy(index: number) {
    if (index === 0) {
      this.sumTotalCost('POL', this.cnsltnOrgQuotCstList, this.orgCstSubTotal.crncyCd,
        totalCost => this.orgCstSubTotal.totalCost = totalCost
      );
    } else if (index === 2) {
      this.sumTotalCost('POD', this.cnsltnDesQuotCstList, this.desCstSubTotal.crncyCd,
        totalCost => this.desCstSubTotal.totalCost = totalCost
      );
    } else if (index === 3) {
      this.setTotalCost();
    } else {
      this.sumTotalCost('TRANS', this.cnsltnTransQuotCstList, this.transCstSubTotal.crncyCd,
        totalCost => this.transCstSubTotal.totalCost = totalCost
      );
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/containers/fare/rate/detail/fare-detail.ts